import { svg } from 'd3'
import { FC, SVGProps, useMemo } from 'react'
import { UseChartContext } from 'components/atoms/chart/useChart'

type ChartLineAreaProps =
  & SVGProps<SVGPathElement>
  & {
    context: UseChartContext
  }
export const ChartLineArea: FC<ChartLineAreaProps> = (props) => {
  const { context, ...restProps } = props

  const lineGenerator = useMemo(() => {
    return svg.area()
      .x((item) => context.scaleX(item[0]))
      .y0(() => context.scaleY(context.yRange[0]))
      .y1((item) => context.scaleY(item[1]))
  }, [context])

  const pathD = useMemo(() => {
    if (!lineGenerator) {
      return null
    }
    return lineGenerator(context.points)
  }, [context.points, lineGenerator])

  if (!pathD) {
    return null
  }

  return (
    <path d={ pathD } { ...restProps } />
  )
}
